export default __webpack_public_path__ + "static/media/profits.3d95459a.svg";